import toggleClass from 'utils/DOM/toggleClass'

function updateDOM(state) {
  toggleClass(state.wrap, 'error', state.error)
  toggleClass(state.wrap, 'valid', state.valid)
}

export default updateDOM
